import {
  DiscoveryApi,
  FetchApi,
  createApiRef,
} from '@backstage/core-plugin-api';
import { CloudRunHealthResponse } from './types';

export interface CloudrunHealthApi {
  getServiceHealth(options: {
    projectId: string;
    region: string;
    serviceName: string;
    healthCheckPath?: string;
  }): Promise<CloudRunHealthResponse>;
}

export const cloudrunHealthApiRef = createApiRef<CloudrunHealthApi>({
  id: 'plugin.cloudrun-health.service',
});

export class CloudrunHealthClient implements CloudrunHealthApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getServiceHealth(options: {
    projectId: string;
    region: string;
    serviceName: string;
    healthCheckPath?: string;
  }): Promise<CloudRunHealthResponse> {
    const baseUrl = await this.discoveryApi.getBaseUrl('cloudrun-health');
    const path = options.healthCheckPath
      ? `?path=${encodeURIComponent(options.healthCheckPath)}`
      : '';
    const url = `${baseUrl}/services/${encodeURIComponent(
      options.projectId,
    )}/${encodeURIComponent(options.region)}/${encodeURIComponent(
      options.serviceName,
    )}${path}`;

    const res = await this.fetchApi.fetch(url);
    if (!res.ok) {
      const errText = await res.text();
      throw new Error(`Falha ao buscar saúde do Cloud Run (${res.status}): ${errText}`);
    }

    return res.json();
  }
}

